var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vz-layout vz-layout-default"},[_c('nuxt'),_vm._v(" "),_c('vz-dialog',{attrs:{"active":_vm.dialog.active,"title":_vm.dialog.title,"type":_vm.dialog.type,"buttons":_vm.dialog.buttons}},[_vm._v("\n    "+_vm._s(_vm.dialog.text)+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }